import { render } from "./7.PricingPage.vue?vue&type=template&id=5c904745&scoped=true"
import script from "./7.PricingPage.vue?vue&type=script&lang=js"
export * from "./7.PricingPage.vue?vue&type=script&lang=js"

import "./7.PricingPage.vue?vue&type=style&index=0&id=5c904745&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c904745"]])

export default __exports__